var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5263 12.6429V11.2381H12.7538C11.225 11.2381 9.9812 9.97774 9.9812 8.42857C9.9812 6.8794 11.225 5.61905 12.7538 5.61905H15.5263V4.21429C15.5263 3.43942 14.9042 2.80952 14.14 2.80952H2.21804C2.07527 2.80305 1.94046 2.74102 1.84169 2.63635C1.74291 2.53169 1.68778 2.39244 1.68778 2.24762C1.68778 2.1028 1.74291 1.96355 1.84169 1.85888C1.94046 1.75421 2.07527 1.69219 2.21804 1.68571H12.4765C12.5857 1.68571 12.6939 1.66391 12.7948 1.62156C12.8957 1.5792 12.9874 1.51711 13.0647 1.43885C13.1419 1.36058 13.2032 1.26766 13.245 1.1654C13.2868 1.06314 13.3083 0.953543 13.3083 0.842857C13.3083 0.732172 13.2868 0.62257 13.245 0.52031C13.2032 0.41805 13.1419 0.325134 13.0647 0.246867C12.9874 0.1686 12.8957 0.106516 12.7948 0.0641586C12.6939 0.0218011 12.5857 0 12.4765 0H2.21804C0.994793 0 0 1.00806 0 2.24762V11.8C0 13.0396 0.994793 14.0476 2.21804 14.0476H14.14C14.9042 14.0476 15.5263 13.4177 15.5263 12.6429ZM15.5263 10.3509V6.65412H12.7537C12.3125 6.65412 11.8894 6.84885 11.5774 7.19549C11.2655 7.54213 11.0902 8.01227 11.0902 8.50249C11.0902 8.99271 11.2655 9.46285 11.5774 9.80948C11.8894 10.1561 12.3125 10.3509 12.7537 10.3509H15.5263Z",
    fill: "url(#paint0_radial_11_249)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11_249",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.5 8) rotate(90) scale(6 7.97428)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.e5757db4c2d3e8216fd5758c704779d8.svg";
export { ForwardRef as ReactComponent };